import { useArticles } from "@/hooks/useArticles";
import { useQuery } from "@tanstack/react-query";
import AdminArticleList from "@/components/AdminArticleList";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const AdminDashboard = () => {
  const { data: articles, isLoading: isLoadingArticles, refetch: refetchArticles } = useArticles();
  
  const { data: specialArticles, isLoading: isLoadingSpecial, refetch: refetchSpecial } = useQuery({
    queryKey: ["special-articles"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("special_articles")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  const handleDelete = (id: string, isSpecial: boolean = false) => {
    if (isSpecial) {
      refetchSpecial();
    } else {
      refetchArticles();
    }
  };

  const isLoading = isLoadingArticles || isLoadingSpecial;

  return (
    <div className="container pt-24 pb-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-display text-magazine-primary">記事管理</h1>
        <div className="space-x-4">
          <Button asChild>
            <Link to="/create-article" className="flex items-center gap-2">
              <Plus className="h-4 w-4" />
              新規記事作成
            </Link>
          </Button>
          <Button asChild variant="secondary">
            <Link to="/create-special-article" className="flex items-center gap-2">
              <Plus className="h-4 w-4" />
              新規スペシャル記事作成
            </Link>
          </Button>
        </div>
      </div>
      <AdminArticleList
        articles={articles}
        specialArticles={specialArticles}
        isLoading={isLoading}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default AdminDashboard;